import { render, staticRenderFns } from "./XTextarea.vue?vue&type=template&id=6e3ba6c8&scoped=true"
import script from "./XTextarea.vue?vue&type=script&lang=js"
export * from "./XTextarea.vue?vue&type=script&lang=js"
import style0 from "./XTextarea.vue?vue&type=style&index=0&id=6e3ba6c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3ba6c8",
  null
  
)

export default component.exports